import React, { Component } from "react";
import Button from '@material-ui/core/Button';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { ReportService } from "../../Services/ReportService";
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const styles = theme =>({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
        flexGrow: 1,
    },
    tablecell: {
        fontSize: '40pt'
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
  });

class StoresReport extends Component {

    constructor(props) {
      super(props);
      this.state = {
        salesStartDate: moment(),
        salesEndDate: moment(),
        returnsStartDate: moment(),
        returnsEndDate: moment()
      }

      props.setTitle('Store Reports');
    }

    handleChangeDate = (date_type, report_type, date) => {

        if(date_type === 'start'){
            if(report_type === 'sales'){
                this.setState({ salesStartDate: date });    
            } else if(report_type === 'returns'){
                this.setState({ returnsStartDate: date });    
            }
        } else if(date_type === 'end'){
            if(report_type === 'sales'){
                this.setState({ salesEndDate: date });
            } else if(report_type === 'returns'){
                this.setState({ returnsEndDate: date });    
            }
        }
        
    }

    exportReport = (report_type, e) => {
        let startDate = report_type === 'sales' ? this.state.salesStartDate : this.state.returnsStartDate;
        let endDate = report_type === 'sales' ? this.state.salesEndDate : this.state.returnsEndDate;
        this.props.isLoading(true);
        ReportService.exportStoreReport(report_type, startDate, endDate)
        .then(response => {
            return response.blob()
        })
        .then((blob) => {
            this.props.isLoading(false);
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', report_type === 'sales' ? 'Sales Report.xlsx' : 'Returns Report.xlsx' );
            // 3. Append to html page
            document.body.appendChild(link);
            // 4. Force download
            link.click();
            // 5. Clean up and remove the link
            link.parentNode.removeChild(link);
        })
        .catch(error => {
            this.props.isLoading(false);
            console.log(error);
        });
        // .then((data) => {
        //     if(data.report.length > 0){
        //         let sheetname = '';
        //         let exportStoreData = [];
        //         if(report_type === 'sales'){
        //             let title = ["Sl. No", "Schedule Date", "Store Name", "Store Phone Number", "Store Address", "Product Name", "Rate", "Scheduled Quantity", "Issued Quantity", "Amount", "Invoice No", "Agent Name"];
        //             exportStoreData = [title];
        //             data.report.forEach((rec, index) => {
        //                 let storeArray = [index + 1, moment(rec.schedule_date).format(format_display_DDMMYYYY), rec.store_name, rec.mobile_no, rec.address, rec.product_display_name ? rec.product_display_name : rec.product_name, parseFloat(rec.rate), rec.issued_qty ? parseInt(rec.issued_qty) : 0, rec.delivered_qty ? parseInt(rec.delivered_qty) : 0, rec.total_amount ? parseFloat(rec.total_amount) : 0, rec.invoice_no ? rec.invoice_no : "-", rec.delivery_agent_name ? rec.delivery_agent_name : "-"];
        //                 exportStoreData.push(storeArray);
        //             });
        //             sheetname = 'Sales Report';
        //         } else if (report_type === 'returns'){
        //             let title = ["Sl. No", "Schedule Date", "Store Name", "Store Phone Number", "Store Address", "Product Name", "Rate", "Returned Quantity", "Amount", "Credit Note No", "Against Inv No", "Agent Name"];
        //             exportStoreData = [title];
        //             data.report.forEach((rec, index) => {
        //                 let storeArray = [index + 1, moment(rec.schedule_date).format(format_display_DDMMYYYY), rec.store_name, rec.mobile_no, rec.address, rec.product_display_name ? rec.product_display_name : rec.product_name, parseFloat(rec.rate), rec.returned_qty ? parseInt(rec.returned_qty) : 0, rec.total_amount ? parseFloat(rec.total_amount) : 0, rec.credit_note_no ? rec.credit_note_no : "-", rec.invoice_no ? rec.invoice_no : "-", rec.delivery_agent_name ? rec.delivery_agent_name : "-"];
        //                 exportStoreData.push(storeArray);
        //             });
        //             sheetname = 'Returns Report';
        //         }
        //         if(exportStoreData){
        //             console.log(exportStoreData);
        //             const wb = XLSX.utils.book_new();
        //             const wsAll = XLSX.utils.aoa_to_sheet(exportStoreData);
        //             XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
        //             XLSX.writeFile(wb, sheetname + ".xlsx");
        //         }
        //         this.props.isLoading(false);
        //     } else {
        //         this.props.showConfirmDialog("There are no records to export", undefined, undefined);
        //         this.props.isLoading(false);
        //     }
        // })
        // .catch(error => {
        //     console.log(error);
        //     this.props.isLoading(false);
        // });
    }
    
    render() {
        const classes = this.props.classes;
        return (
            <div className="Home sales-stats" style={{marginTop: 32}}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Paper className={classes.paper}>
                            <Grid container spacing={8}>
                                <Grid item xs={3}>
                                    <Typography variant="h6" gutterBottom  style={{marginTop: 25}}>
                                        Sales Report
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            variant="dialog"
                                            inputVariant="outlined"
                                            margin="normal"
                                            label="From"
                                            value={this.state.salesStartDate}
                                            onChange={(e) => this.handleChangeDate('start', 'sales', e)}
                                            format='DD MMM YYYY'
                                            maxDate={this.state.salesEndDate}
                                            className={classes.formControl}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={3}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            variant="dialog"
                                            inputVariant="outlined"
                                            margin="normal"
                                            label="To"
                                            value={this.state.salesEndDate}
                                            minDate={this.state.salesStartDate}
                                            onChange={(e) => this.handleChangeDate('end', 'sales', e)}
                                            format='DD MMM YYYY'
                                            className={classes.formControl}
                                            disableFuture
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={3}>
                                    <Button style={{marginTop: 20}} variant="outlined" size="large" color="primary" onClick={(e) => this.exportReport('sales', e)}>Export</Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={12}>
                    <Paper className={classes.paper}>
                            <Grid container spacing={8}>
                                <Grid item xs={3}>
                                    <Typography variant="h6" gutterBottom  style={{marginTop: 25}}>
                                        Returns Report
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            margin="normal"
                                            variant="dialog"
                                            inputVariant="outlined"
                                            label="From"
                                            value={this.state.returnsStartDate}
                                            onChange={(e) => this.handleChangeDate('start', 'returns', e)}
                                            format='DD MMM YYYY'
                                            maxDate={this.state.returnsEndDate}
                                            className={classes.formControl}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={3}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            margin="normal"
                                            label="To"
                                            value={this.state.returnsEndDate}
                                            onChange={(e) => this.handleChangeDate('end', 'returns', e)}
                                            format='DD MMM YYYY'
                                            variant="dialog"
                                            inputVariant="outlined"
                                            className={classes.formControl}
                                            disableFuture
                                            minDate={this.state.returnsStartDate}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={3}>
                                    <Button style={{marginTop: 20}} variant="outlined" size="large" color="primary" onClick={(e) => this.exportReport('returns', e)}>Export</Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(StoresReport);